module.exports = __webpack_public_path__ + "static/media/9.04ee3a77.jpeg";